'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdDoNotDisturbAlt = function MdDoNotDisturbAlt(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 33.4q5.5 0 9.4-4t4-9.4q0-4.4-2.9-8.2l-18.7 18.7q3.8 2.9 8.2 2.9z m-13.4-13.4q0 4.5 2.9 8.2l18.7-18.7q-3.8-2.9-8.2-2.9-5.5 0-9.4 4t-4 9.4z m13.4-16.6q6.9 0 11.8 4.8t4.8 11.8-4.8 11.8-11.8 4.8-11.8-4.8-4.8-11.8 4.8-11.8 11.8-4.8z' })
        )
    );
};

exports.default = MdDoNotDisturbAlt;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/do-not-disturb-alt.js
// module id = 2774
// module chunks = 0